import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubblePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-plus, comment, feedback"} maskId="square-filled-radius-0-stroke-1-IconBubblePlus"><path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3.00002V19H15.1957L11.996 21.6509L8.83366 19L3 19V3ZM12.5 7.00003L11.5 7.00003L11.5 10.5H8V11.5H11.5L11.5 15H12.5L12.5 11.5H16V10.5L12.5 10.5L12.5 7.00003Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubblePlus;
